// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-name-container {
  margin: 10px 0;
  font-size: 14px;
  color: #333;
}
.image-name {
  margin: 5px 0;
  border-bottom: 1px solid #ddd;
}

.stickHead table {
  width: 100%;
}

.noPendingOrders {
  height: 35vh;
  width: 100%;
  text-align: center;
  vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./src/Css/Pending.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB","sourcesContent":[".image-name-container {\r\n  margin: 10px 0;\r\n  font-size: 14px;\r\n  color: #333;\r\n}\r\n.image-name {\r\n  margin: 5px 0;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n\r\n.stickHead table {\r\n  width: 100%;\r\n}\r\n\r\n.noPendingOrders {\r\n  height: 35vh;\r\n  width: 100%;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
